export const mockWholesaleFactories = [
  {
    id: "wf1",
    name: "SinoTech Electronics Co.",
    country: "China",
    region: "Asia",
    flag: "🇨🇳",
    city: "Shenzhen, Guangdong",
    avatar: "https://public.readdy.ai/ai/img_res/2d492c76625ab50667f014637e621ed6.jpg",
    banner: "https://readdy.ai/api/search-image?query=large%20modern%20electronics%20factory%20interior%20shenzhen%20china%20production%20line%20workers%20clean%20professional%20wide%20shot&width=800&height=300&seq=wfbanner1&orientation=landscape",
    verified: true,
    rating: 4.8,
    totalOrders: 1240,
    yearsActive: 12,
    category: "Consumer Electronics",
    certifications: ["ISO 9001", "CE", "FCC", "RoHS"],
    minOrderUSD: 8000,
    containerTypes: ["20ft", "40ft", "40ft HC"],
    responseTime: "< 4 hours",
    sampleAvailable: true,
    samplePrice: 150,
    sampleLeadTime: "5-7 days",
    bulkLeadTime: "25-35 days",
    about: "One of Shenzhen's top-tier electronics OEM/ODM manufacturers with 12 years of export experience. Specializing in wireless audio, smart home devices, and consumer gadgets. Trusted by buyers in 80+ countries.",
    products: [
      {
        id: "wp1",
        title: "TWS Wireless Earbuds — OEM/ODM",
        unitPrice: 8.50,
        moqUnits: 1000,
        moqUSD: 8500,
        containerQty: { "20ft": 18000, "40ft": 38000 },
        image: "https://readdy.ai/api/search-image?query=wireless%20earbuds%20bulk%20wholesale%20packaging%20factory%20oem%20white%20background%20product%20photography&width=400&height=400&seq=wp1&orientation=squarish",
        category: "Electronics",
        customizable: true,
      },
      {
        id: "wp2",
        title: "Smart LED Strip Lights 5M",
        unitPrice: 4.20,
        moqUnits: 2000,
        moqUSD: 8400,
        containerQty: { "20ft": 45000, "40ft": 92000 },
        image: "https://readdy.ai/api/search-image?query=smart%20LED%20strip%20lights%20colorful%20bulk%20wholesale%20packaging%20factory%20product%20photography%20white%20background&width=400&height=400&seq=wp2&orientation=squarish",
        category: "Electronics",
        customizable: true,
      },
    ],
  },
  {
    id: "wf2",
    name: "GreenThread Textile Mills",
    country: "USA",
    region: "USA",
    flag: "🇺🇸",
    city: "Los Angeles, CA",
    avatar: "https://readdy.ai/api/search-image?query=american%20textile%20company%20logo%20green%20leaf%20professional%20clean%20minimal%20circle%20icon&width=80&height=80&seq=wfav2&orientation=squarish",
    banner: "https://readdy.ai/api/search-image?query=modern%20american%20textile%20factory%20interior%20los%20angeles%20production%20line%20fabric%20clothing%20manufacturing%20professional&width=800&height=300&seq=wfbanner2&orientation=landscape",
    verified: true,
    rating: 4.9,
    totalOrders: 890,
    yearsActive: 8,
    category: "Fashion & Apparel",
    certifications: ["GOTS Organic", "OEKO-TEX", "Fair Trade", "ISO 9001"],
    minOrderUSD: 8000,
    containerTypes: ["20ft", "40ft"],
    responseTime: "< 2 hours",
    sampleAvailable: true,
    samplePrice: 80,
    sampleLeadTime: "3-5 days",
    bulkLeadTime: "15-25 days",
    about: "Los Angeles-based organic cotton manufacturer supplying fashion brands across North America and Europe. GOTS certified, Fair Trade compliant. Custom branding and private label available from MOQ.",
    products: [
      {
        id: "wp3",
        title: "Organic Cotton Hoodies — Private Label",
        unitPrice: 12.50,
        moqUnits: 640,
        moqUSD: 8000,
        containerQty: { "20ft": 8000, "40ft": 16500 },
        image: "https://readdy.ai/api/search-image?query=organic%20cotton%20hoodies%20bulk%20wholesale%20stack%20folded%20clean%20white%20background%20product%20photography&width=400&height=400&seq=wp3&orientation=squarish",
        category: "Fashion",
        customizable: true,
      },
      {
        id: "wp4",
        title: "Premium Cotton T-Shirts Bulk",
        unitPrice: 5.80,
        moqUnits: 1380,
        moqUSD: 8004,
        containerQty: { "20ft": 22000, "40ft": 46000 },
        image: "https://readdy.ai/api/search-image?query=premium%20cotton%20t-shirts%20bulk%20wholesale%20stack%20folded%20multiple%20colors%20white%20background%20product%20photography&width=400&height=400&seq=wp4&orientation=squarish",
        category: "Fashion",
        customizable: true,
      },
    ],
  },
  {
    id: "wf3",
    name: "EuroHome Furniture GmbH",
    country: "Germany",
    region: "Europe",
    flag: "🇩🇪",
    city: "Stuttgart, Germany",
    avatar: "https://readdy.ai/api/search-image?query=german%20furniture%20company%20logo%20professional%20clean%20minimal%20circle%20icon%20modern&width=80&height=80&seq=wfav3&orientation=squarish",
    banner: "https://readdy.ai/api/search-image?query=modern%20german%20furniture%20factory%20interior%20production%20line%20wood%20manufacturing%20professional%20wide%20shot%20clean&width=800&height=300&seq=wfbanner3&orientation=landscape",
    verified: true,
    rating: 4.7,
    totalOrders: 560,
    yearsActive: 22,
    category: "Home & Furniture",
    certifications: ["FSC Certified", "ISO 14001", "PEFC", "CE"],
    minOrderUSD: 10000,
    containerTypes: ["20ft", "40ft", "40ft HC"],
    responseTime: "< 6 hours",
    sampleAvailable: true,
    samplePrice: 300,
    sampleLeadTime: "7-10 days",
    bulkLeadTime: "30-45 days",
    about: "Stuttgart-based premium furniture manufacturer with 22 years of export experience. Specializing in Scandinavian-inspired solid wood furniture for residential and commercial buyers. FSC certified sustainable sourcing.",
    products: [
      {
        id: "wp5",
        title: "Solid Oak Dining Table Set",
        unitPrice: 280.00,
        moqUnits: 36,
        moqUSD: 10080,
        containerQty: { "20ft": 36, "40ft": 80 },
        image: "https://readdy.ai/api/search-image?query=solid%20oak%20dining%20table%20set%20modern%20minimalist%20furniture%20white%20background%20product%20photography%20clean&width=400&height=400&seq=wp5&orientation=squarish",
        category: "Furniture",
        customizable: false,
      },
      {
        id: "wp6",
        title: "Modular Bookshelf System",
        unitPrice: 145.00,
        moqUnits: 56,
        moqUSD: 8120,
        containerQty: { "20ft": 120, "40ft": 260 },
        image: "https://readdy.ai/api/search-image?query=modular%20bookshelf%20system%20modern%20wood%20white%20background%20product%20photography%20clean%20minimal&width=400&height=400&seq=wp6&orientation=squarish",
        category: "Furniture",
        customizable: true,
      },
    ],
  },
  {
    id: "wf4",
    name: "NorthPack Canada Inc.",
    country: "Canada",
    region: "Canada",
    flag: "🇨🇦",
    city: "Vancouver, BC",
    avatar: "https://readdy.ai/api/search-image?query=canadian%20packaging%20company%20logo%20professional%20clean%20minimal%20circle%20icon%20maple%20leaf&width=80&height=80&seq=wfav4&orientation=squarish",
    banner: "https://readdy.ai/api/search-image?query=modern%20canadian%20packaging%20factory%20interior%20vancouver%20production%20line%20eco%20packaging%20manufacturing%20professional&width=800&height=300&seq=wfbanner4&orientation=landscape",
    verified: true,
    rating: 4.8,
    totalOrders: 430,
    yearsActive: 9,
    category: "Eco Packaging & Outdoor",
    certifications: ["FSC Certified", "ISO 9001", "BPI Compostable", "B Corp"],
    minOrderUSD: 8000,
    containerTypes: ["20ft", "40ft"],
    responseTime: "< 3 hours",
    sampleAvailable: true,
    samplePrice: 120,
    sampleLeadTime: "4-6 days",
    bulkLeadTime: "20-30 days",
    about: "Vancouver-based eco-packaging and outdoor gear manufacturer. B Corp certified, 100% compostable packaging solutions and premium outdoor equipment. Supplying retailers across North America, Europe, and Australia.",
    products: [
      {
        id: "wp7",
        title: "Compostable Kraft Packaging Set",
        unitPrice: 0.85,
        moqUnits: 10000,
        moqUSD: 8500,
        containerQty: { "20ft": 180000, "40ft": 380000 },
        image: "https://readdy.ai/api/search-image?query=compostable%20kraft%20eco%20packaging%20boxes%20bulk%20wholesale%20white%20background%20product%20photography%20clean&width=400&height=400&seq=wp7&orientation=squarish",
        category: "Packaging",
        customizable: true,
      },
    ],
  },
  {
    id: "wf5",
    name: "KoreaBeauty Factory Co.",
    country: "South Korea",
    region: "Asia",
    flag: "🇰🇷",
    city: "Seoul, South Korea",
    avatar: "https://readdy.ai/api/search-image?query=korean%20beauty%20cosmetics%20company%20logo%20professional%20clean%20minimal%20circle%20icon%20pink&width=80&height=80&seq=wfav5&orientation=squarish",
    banner: "https://readdy.ai/api/search-image?query=modern%20korean%20beauty%20cosmetics%20factory%20interior%20seoul%20production%20line%20skincare%20manufacturing%20professional%20clean&width=800&height=300&seq=wfbanner5&orientation=landscape",
    verified: true,
    rating: 4.9,
    totalOrders: 2100,
    yearsActive: 15,
    category: "K-Beauty & Skincare",
    certifications: ["KFDA Approved", "ISO 22716 GMP", "Cruelty-Free", "Vegan Certified"],
    minOrderUSD: 8000,
    containerTypes: ["20ft", "40ft"],
    responseTime: "< 2 hours",
    sampleAvailable: true,
    samplePrice: 95,
    sampleLeadTime: "3-5 days",
    bulkLeadTime: "20-28 days",
    about: "Seoul's leading K-Beauty OEM/ODM manufacturer with 15 years of global export experience. KFDA approved, GMP certified. Private label skincare, sheet masks, serums, and cosmetics for brands worldwide.",
    products: [
      {
        id: "wp8",
        title: "Hyaluronic Acid Serum — OEM",
        unitPrice: 3.20,
        moqUnits: 2500,
        moqUSD: 8000,
        containerQty: { "20ft": 55000, "40ft": 115000 },
        image: "https://readdy.ai/api/search-image?query=hyaluronic%20acid%20serum%20bottle%20bulk%20wholesale%20korean%20beauty%20oem%20white%20background%20product%20photography&width=400&height=400&seq=wp8&orientation=squarish",
        category: "Beauty",
        customizable: true,
      },
      {
        id: "wp9",
        title: "Sheet Mask Set — Private Label",
        unitPrice: 0.95,
        moqUnits: 10000,
        moqUSD: 9500,
        containerQty: { "20ft": 200000, "40ft": 420000 },
        image: "https://readdy.ai/api/search-image?query=sheet%20mask%20set%20bulk%20wholesale%20korean%20beauty%20private%20label%20packaging%20white%20background%20product%20photography&width=400&height=400&seq=wp9&orientation=squarish",
        category: "Beauty",
        customizable: true,
      },
    ],
  },
  {
    id: "wf6",
    name: "IndiaSpice Foods Pvt. Ltd.",
    country: "India",
    region: "Asia",
    flag: "🇮🇳",
    city: "Mumbai, Maharashtra",
    avatar: "https://readdy.ai/api/search-image?query=indian%20food%20company%20logo%20professional%20clean%20minimal%20circle%20icon%20spice&width=80&height=80&seq=wfav6&orientation=squarish",
    banner: "https://readdy.ai/api/search-image?query=modern%20indian%20food%20factory%20interior%20mumbai%20production%20line%20spices%20food%20manufacturing%20professional%20clean%20wide%20shot&width=800&height=300&seq=wfbanner6&orientation=landscape",
    verified: true,
    rating: 4.6,
    totalOrders: 780,
    yearsActive: 18,
    category: "Food & Spices",
    certifications: ["FSSAI", "ISO 22000", "HACCP", "Organic India"],
    minOrderUSD: 8000,
    containerTypes: ["20ft", "40ft"],
    responseTime: "< 5 hours",
    sampleAvailable: true,
    samplePrice: 60,
    sampleLeadTime: "5-8 days",
    bulkLeadTime: "18-25 days",
    about: "Mumbai-based premium spice and food ingredient exporter with 18 years of global trade experience. FSSAI and ISO 22000 certified. Supplying supermarkets, restaurants, and food brands across 60+ countries.",
    products: [
      {
        id: "wp10",
        title: "Premium Spice Blend Collection",
        unitPrice: 6.50,
        moqUnits: 1230,
        moqUSD: 7995,
        containerQty: { "20ft": 28000, "40ft": 58000 },
        image: "https://readdy.ai/api/search-image?query=premium%20spice%20blend%20collection%20bulk%20wholesale%20jars%20packaging%20white%20background%20product%20photography%20clean&width=400&height=400&seq=wp10&orientation=squarish",
        category: "Food",
        customizable: true,
      },
    ],
  },
  {
    id: "wf7",
    name: "ItaliaLeather S.r.l.",
    country: "Italy",
    region: "Europe",
    flag: "🇮🇹",
    city: "Florence, Italy",
    avatar: "https://readdy.ai/api/search-image?query=italian%20leather%20goods%20company%20logo%20professional%20clean%20minimal%20circle%20icon%20luxury&width=80&height=80&seq=wfav7&orientation=squarish",
    banner: "https://readdy.ai/api/search-image?query=italian%20leather%20goods%20factory%20interior%20florence%20artisan%20workshop%20luxury%20handbags%20manufacturing%20professional%20wide%20shot&width=800&height=300&seq=wfbanner7&orientation=landscape",
    verified: true,
    rating: 4.9,
    totalOrders: 340,
    yearsActive: 35,
    category: "Luxury Leather Goods",
    certifications: ["ICEC Certified", "ISO 9001", "REACH Compliant", "Made in Italy"],
    minOrderUSD: 12000,
    containerTypes: ["20ft", "40ft"],
    responseTime: "< 8 hours",
    sampleAvailable: true,
    samplePrice: 450,
    sampleLeadTime: "10-14 days",
    bulkLeadTime: "45-60 days",
    about: "Florence-based luxury leather goods manufacturer with 35 years of artisan craftsmanship. Genuine Italian leather handbags, wallets, and accessories. Supplying luxury retailers and fashion brands globally.",
    products: [
      {
        id: "wp11",
        title: "Genuine Italian Leather Handbags",
        unitPrice: 85.00,
        moqUnits: 142,
        moqUSD: 12070,
        containerQty: { "20ft": 2800, "40ft": 6000 },
        image: "https://readdy.ai/api/search-image?query=genuine%20italian%20leather%20handbag%20luxury%20bulk%20wholesale%20white%20background%20product%20photography%20clean%20minimal&width=400&height=400&seq=wp11&orientation=squarish",
        category: "Fashion",
        customizable: true,
      },
      {
        id: "wp12",
        title: "Leather Wallet Collection — OEM",
        unitPrice: 22.00,
        moqUnits: 400,
        moqUSD: 8800,
        containerQty: { "20ft": 18000, "40ft": 38000 },
        image: "https://readdy.ai/api/search-image?query=leather%20wallet%20collection%20bulk%20wholesale%20oem%20white%20background%20product%20photography%20clean%20minimal&width=400&height=400&seq=wp12&orientation=squarish",
        category: "Fashion",
        customizable: true,
      },
    ],
  },
  {
    id: "wf8",
    name: "TurkeyTextile A.Ş.",
    country: "Turkey",
    region: "Europe",
    flag: "🇹🇷",
    city: "Istanbul, Turkey",
    avatar: "https://readdy.ai/api/search-image?query=turkish%20textile%20company%20logo%20professional%20clean%20minimal%20circle%20icon%20fabric&width=80&height=80&seq=wfav8&orientation=squarish",
    banner: "https://readdy.ai/api/search-image?query=modern%20turkish%20textile%20factory%20interior%20istanbul%20production%20line%20fabric%20denim%20manufacturing%20professional%20wide%20shot&width=800&height=300&seq=wfbanner8&orientation=landscape",
    verified: true,
    rating: 4.7,
    totalOrders: 1560,
    yearsActive: 20,
    category: "Denim & Knitwear",
    certifications: ["OEKO-TEX", "ISO 9001", "GOTS", "Bluesign"],
    minOrderUSD: 8000,
    containerTypes: ["20ft", "40ft", "40ft HC"],
    responseTime: "< 3 hours",
    sampleAvailable: true,
    samplePrice: 70,
    sampleLeadTime: "4-6 days",
    bulkLeadTime: "20-30 days",
    about: "Istanbul's leading denim and knitwear manufacturer with 20 years of global export experience. OEKO-TEX certified. Supplying fashion brands across Europe, USA, and the Middle East with premium denim jeans, jackets, and knitwear.",
    products: [
      {
        id: "wp13",
        title: "Premium Denim Jeans — OEM",
        unitPrice: 9.80,
        moqUnits: 820,
        moqUSD: 8036,
        containerQty: { "20ft": 14000, "40ft": 30000 },
        image: "https://readdy.ai/api/search-image?query=premium%20denim%20jeans%20bulk%20wholesale%20stack%20folded%20white%20background%20product%20photography%20clean&width=400&height=400&seq=wp13&orientation=squarish",
        category: "Fashion",
        customizable: true,
      },
    ],
  },
  {
    id: "wf9",
    name: "VietnamFurni Co., Ltd.",
    country: "Vietnam",
    region: "Asia",
    flag: "🇻🇳",
    city: "Ho Chi Minh City",
    avatar: "https://readdy.ai/api/search-image?query=vietnamese%20furniture%20company%20logo%20professional%20clean%20minimal%20circle%20icon%20wood&width=80&height=80&seq=wfav9&orientation=squarish",
    banner: "https://readdy.ai/api/search-image?query=modern%20vietnamese%20furniture%20factory%20interior%20ho%20chi%20minh%20city%20production%20line%20wood%20rattan%20manufacturing%20professional%20wide%20shot&width=800&height=300&seq=wfbanner9&orientation=landscape",
    verified: true,
    rating: 4.6,
    totalOrders: 920,
    yearsActive: 14,
    category: "Rattan & Wood Furniture",
    certifications: ["FSC Certified", "ISO 9001", "CARB Compliant", "BSCI"],
    minOrderUSD: 8000,
    containerTypes: ["20ft", "40ft", "40ft HC"],
    responseTime: "< 5 hours",
    sampleAvailable: true,
    samplePrice: 200,
    sampleLeadTime: "7-10 days",
    bulkLeadTime: "35-50 days",
    about: "Ho Chi Minh City-based rattan and solid wood furniture manufacturer. FSC certified, CARB compliant. Exporting to USA, Europe, and Australia. Specializing in indoor and outdoor furniture with custom design capability.",
    products: [
      {
        id: "wp14",
        title: "Rattan Outdoor Furniture Set",
        unitPrice: 165.00,
        moqUnits: 50,
        moqUSD: 8250,
        containerQty: { "20ft": 50, "40ft": 110 },
        image: "https://readdy.ai/api/search-image?query=rattan%20outdoor%20furniture%20set%20bulk%20wholesale%20white%20background%20product%20photography%20clean%20minimal&width=400&height=400&seq=wp14&orientation=squarish",
        category: "Furniture",
        customizable: true,
      },
    ],
  },
  {
    id: "wf10",
    name: "JapanPrecision Mfg. K.K.",
    country: "Japan",
    region: "Asia",
    flag: "🇯🇵",
    city: "Osaka, Japan",
    avatar: "https://readdy.ai/api/search-image?query=japanese%20precision%20manufacturing%20company%20logo%20professional%20clean%20minimal%20circle%20icon%20technology&width=80&height=80&seq=wfav10&orientation=squarish",
    banner: "https://readdy.ai/api/search-image?query=modern%20japanese%20precision%20manufacturing%20factory%20interior%20osaka%20production%20line%20technology%20clean%20professional%20wide%20shot&width=800&height=300&seq=wfbanner10&orientation=landscape",
    verified: true,
    rating: 5.0,
    totalOrders: 480,
    yearsActive: 28,
    category: "Precision Tools & Hardware",
    certifications: ["JIS Certified", "ISO 9001", "ISO 14001", "CE"],
    minOrderUSD: 10000,
    containerTypes: ["20ft", "40ft"],
    responseTime: "< 6 hours",
    sampleAvailable: true,
    samplePrice: 280,
    sampleLeadTime: "7-12 days",
    bulkLeadTime: "30-40 days",
    about: "Osaka-based precision tools and hardware manufacturer with 28 years of excellence. JIS and ISO certified. Supplying industrial buyers, hardware retailers, and construction companies across Asia, USA, and Europe.",
    products: [
      {
        id: "wp15",
        title: "Professional Tool Set — 120pc",
        unitPrice: 42.00,
        moqUnits: 240,
        moqUSD: 10080,
        containerQty: { "20ft": 3200, "40ft": 6800 },
        image: "https://readdy.ai/api/search-image?query=professional%20tool%20set%20120%20piece%20bulk%20wholesale%20white%20background%20product%20photography%20clean%20minimal&width=400&height=400&seq=wp15&orientation=squarish",
        category: "Hardware",
        customizable: false,
      },
    ],
  },
  {
    id: "wf11",
    name: "TexasFit Manufacturing LLC",
    country: "USA",
    region: "USA",
    flag: "🇺🇸",
    city: "Dallas, TX",
    avatar: "https://readdy.ai/api/search-image?query=american%20fitness%20equipment%20company%20logo%20professional%20clean%20minimal%20circle%20icon%20sports&width=80&height=80&seq=wfav11&orientation=squarish",
    banner: "https://readdy.ai/api/search-image?query=modern%20american%20fitness%20equipment%20factory%20interior%20dallas%20texas%20production%20line%20gym%20equipment%20manufacturing%20professional&width=800&height=300&seq=wfbanner11&orientation=landscape",
    verified: true,
    rating: 4.8,
    totalOrders: 670,
    yearsActive: 11,
    category: "Fitness & Sports Equipment",
    certifications: ["ISO 9001", "ASTM Certified", "CE", "SGS Tested"],
    minOrderUSD: 8000,
    containerTypes: ["20ft", "40ft", "40ft HC"],
    responseTime: "< 2 hours",
    sampleAvailable: true,
    samplePrice: 180,
    sampleLeadTime: "3-5 days",
    bulkLeadTime: "15-25 days",
    about: "Dallas-based fitness equipment manufacturer supplying gyms, hotels, and retailers across North America and Europe. ASTM certified. Custom branding available. Local US warehouse for fast domestic shipping.",
    products: [
      {
        id: "wp16",
        title: "Commercial Gym Dumbbell Set",
        unitPrice: 38.00,
        moqUnits: 212,
        moqUSD: 8056,
        containerQty: { "20ft": 1800, "40ft": 3800 },
        image: "https://readdy.ai/api/search-image?query=commercial%20gym%20dumbbell%20set%20bulk%20wholesale%20white%20background%20product%20photography%20clean%20minimal&width=400&height=400&seq=wp16&orientation=squarish",
        category: "Sports",
        customizable: true,
      },
      {
        id: "wp17",
        title: "Resistance Band Pro Set — 5 Level",
        unitPrice: 6.20,
        moqUnits: 1300,
        moqUSD: 8060,
        containerQty: { "20ft": 42000, "40ft": 88000 },
        image: "https://readdy.ai/api/search-image?query=resistance%20band%20pro%20set%205%20level%20bulk%20wholesale%20white%20background%20product%20photography%20clean&width=400&height=400&seq=wp17&orientation=squarish",
        category: "Sports",
        customizable: true,
      },
    ],
  },
  {
    id: "wf12",
    name: "FranceLuxe Cosmetics S.A.S.",
    country: "France",
    region: "Europe",
    flag: "🇫🇷",
    city: "Paris, France",
    avatar: "https://readdy.ai/api/search-image?query=french%20luxury%20cosmetics%20company%20logo%20professional%20clean%20minimal%20circle%20icon%20elegant&width=80&height=80&seq=wfav12&orientation=squarish",
    banner: "https://readdy.ai/api/search-image?query=modern%20french%20luxury%20cosmetics%20factory%20interior%20paris%20production%20line%20perfume%20beauty%20manufacturing%20professional%20clean&width=800&height=300&seq=wfbanner12&orientation=landscape",
    verified: true,
    rating: 4.9,
    totalOrders: 890,
    yearsActive: 25,
    category: "Luxury Cosmetics & Perfume",
    certifications: ["ISO 22716 GMP", "ECOCERT", "Cruelty-Free", "REACH Compliant"],
    minOrderUSD: 10000,
    containerTypes: ["20ft", "40ft"],
    responseTime: "< 4 hours",
    sampleAvailable: true,
    samplePrice: 220,
    sampleLeadTime: "7-10 days",
    bulkLeadTime: "28-40 days",
    about: "Paris-based luxury cosmetics and perfume manufacturer with 25 years of excellence. GMP certified, ECOCERT organic. Private label fragrances, skincare, and makeup for luxury brands worldwide.",
    products: [
      {
        id: "wp18",
        title: "Luxury Eau de Parfum — OEM",
        unitPrice: 18.50,
        moqUnits: 540,
        moqUSD: 9990,
        containerQty: { "20ft": 22000, "40ft": 46000 },
        image: "https://readdy.ai/api/search-image?query=luxury%20eau%20de%20parfum%20bottle%20bulk%20wholesale%20oem%20white%20background%20product%20photography%20clean%20minimal%20elegant&width=400&height=400&seq=wp18&orientation=squarish",
        category: "Beauty",
        customizable: true,
      },
    ],
  },
];

export const mockWholesaleRegions = [
  { id: "all", label: "All Regions", icon: "ri-global-line" },
  { id: "USA", label: "🇺🇸 USA", icon: "ri-map-pin-line", flag: "🇺🇸" },
  { id: "Canada", label: "🇨🇦 Canada", icon: "ri-map-pin-line", flag: "🇨🇦" },
  { id: "Europe", label: "🌍 Europe", icon: "ri-map-pin-line", flag: "🌍" },
  { id: "Asia", label: "🌏 Asia", icon: "ri-map-pin-line", flag: "🌏" },
];

export const mockContainerPricing = [
  { type: "20ft", label: "20ft Container", capacity: "~25 CBM / ~28,000 kg", icon: "ri-truck-line", desc: "Ideal for smaller bulk orders" },
  { type: "40ft", label: "40ft Container", capacity: "~55 CBM / ~26,500 kg", icon: "ri-truck-line", desc: "Most popular for wholesale" },
  { type: "40ft HC", label: "40ft High Cube", capacity: "~67 CBM / ~26,300 kg", icon: "ri-truck-line", desc: "Best for light, voluminous goods" },
];
